var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongZhankaiXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5h-13M9.5 6h-8M9.5 10h-8M14.5 14h-13",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.816 8.154a.2.2 0 000-.308l-2.488-2.073a.2.2 0 00-.328.154v4.146a.2.2 0 00.328.154l2.488-2.073z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_zhankai_xian.eee0fa8f.svg";
export { SvgTongyongZhankaiXian as ReactComponent };